module.exports = __webpack_public_path__ + "static/moonpig_white-20461d0e24316e803e00a0146c30c37e.png";